import { Result, Ok, Err } from "@pairtreefamily/utils";
import { getClient } from "../../lib/sanity.server";
import * as Sentry from "@sentry/nextjs";

type SanityQueryParams = {
  [key: string]: any;
};

export type CMSResult<T, E = any> = Result<T, E>;

export type CMSQueryArgs = {
  preview?: boolean;
  query: string;
  queryParams?: SanityQueryParams;
};

export async function cmsQuery<T>({
  preview,
  query,
  queryParams,
}: CMSQueryArgs): Promise<CMSResult<T>> {
  try {
    const cmsResponse = await getClient(preview).fetch(
      query,
      queryParams ?? {},
    );
    return Ok(cmsResponse);
  } catch (e) {
    Sentry.captureException(e);
    return Err(e);
  }
}
